<!-- 时间选择弹窗 -->
<template>
  <div class="time-select">
    <vanPopup
      v-model="showPopup"
      position="bottom"
      :round="true"
      :lock-scroll="false"
      @click-overlay="closePopup"
      v-backFn="{ show: showPopup, closeFn: 'closePopup' }"
    >
      <div class="popup-wrap">
        <div class="popup-head">
          <div class="popup-title os-font-16-500">{{ title }}</div>
          <div class="popup-close" @click="closePopup"></div>
        </div>
        <div class="popup-content">
          <template v-if="repairTimeList && repairTimeList.length">
            <div class="day-top os-font-12-500">
              <div
                :class="['day-list', { 'day-list-active': currentIndex === index }]"
                v-for="(item, index) in repairTimeList"
                :key="index"
              >
                <div class="day-list-item" @click="selectDay(index)">
                  <div class="day-item">
                    {{ item.dayAlias || (item.week && item.week.replace('星期', '周')) }}
                  </div>
                  <div class="day-week os-font-10-500">{{ item.day | formatYear }}</div>
                </div>
              </div>
            </div>
            <div class="day-detail os-font-12-500" v-if="repairTimeList[currentIndex]">
              <div class="day-detail-list">
                <div
                  :class="[
                    'day-detail-item',
                    {
                      'day-detail-active': currentTimeIndex === index,
                      'day-detail-disabled': timeItem.expired
                    }
                  ]"
                  @click="
                    selectTime(
                      repairTimeList[currentIndex].week,
                      timeItem,
                      index,
                      repairTimeList[currentIndex].day
                    )
                  "
                  v-for="(timeItem, index) in repairTimeList[currentIndex].times"
                  :key="index"
                >
                  <div class="item-day">{{ timeItem.newTimeslot }}</div>
                  <div class="item-day os-font-10-500">
                    {{ timeItem.explain }}
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div v-if="loadingFlag" class="no-result">
              <div class="no-info-img"></div>
              <div class="no-info os-font-14-500">正在加载</div>
            </div>
            <div v-else-if="repairTimeList && repairTimeList.length == 0" class="no-result">
              <div class="no-info-img-wrap">
                <div class="no-info-img-search"></div>
                <div class="no-info-search os-font-14-500">无可选时段，请尝试切换地址和服务</div>
              </div>
            </div>
          </template>
        </div>
        <div class="popup-bottom os-font-16-500" @click="selectConfirm">
          <div :class="['popup-button', { 'popup-button-disabled': currentTimeIndex === -1 }]">
            {{ footerText }}
          </div>
        </div>
      </div>
    </vanPopup>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'timeSelect',
  props: {
    title: {
      type: String,
      default: '请选择时间段'
    },
    // 底部按钮文案
    footerText: {
      type: String,
      default: '确定'
    }
  },
  data() {
    return {
      showPopup: false,
      currentIndex: 0,
      currentTimeIndex: -1,
      stateTimeObj: null
    }
  },
  mounted() {
    // this.openPopup()
  },
  watch: {
    repairTimeList(val) {
      if (val && val.length > 0) {
        // 重置状态
        this.currentIndex = 0
        this.currentTimeIndex = -1
        this.stateTimeObj = null
        this.RESET_STATE('selectedTime')
        // 自动选中
        this.autoSelect()
      }
    }
  },
  computed: {
    ...mapState('repair', ['repairTimeList', 'loadingFlag']),
    autoIndex() {
      let timeAutoIndex = -1
      let dayAutoIndex = -1

      this.repairTimeList.some((day, dayIndex) => {
        let hasAutoSelectedTime = false

        if (day.times && day.times.length > 0) {
          day.times.some((time, timeIndex) => {
            // 找到第一个可预约的日期和时间段
            if (!time.expired && (dayAutoIndex === -1 || timeAutoIndex === -1)) {
              dayAutoIndex = dayIndex
              timeAutoIndex = timeIndex
              hasAutoSelectedTime = true
              return true
            } else {
              return false
            }
          })
        }

        return hasAutoSelectedTime
      })

      return {
        dayAutoIndex,
        timeAutoIndex
      }
    }
  },
  methods: {
    ...mapMutations('repair', ['SET_SELECTED_TIME', 'RESET_STATE']),
    // 阻止页面滑动
    preventPageScroll() {
      if (this.isPrevent || document.body.classList.contains('isPrevent')) {
        return
      }

      this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      this.marginTop = document.body.style.marginTop
      this.height = document.body.style.height
      this.overflow = document.body.style.overflow
      Object.assign(document.body.style, {
        marginTop: -this.scrollTop + 'px',
        height: window.innerHeight + this.scrollTop + 'px',
        overflow: 'hidden'
      })
      document.body.classList.add('isPrevent')
      this.isPrevent = true
    },
    // 恢复页面滑动
    restorePageScroll() {
      if (!this.isPrevent) {
        return
      }

      Object.assign(document.body.style, {
        marginTop: this.marginTop,
        height: this.height,
        overflow: this.overflow
      })
      document.documentElement.scrollTop = document.body.scrollTop = this.scrollTop
      document.body.classList.remove('isPrevent')
      this.isPrevent = false
    },
    openPopup() {
      this.preventPageScroll()
      this.$nextTick(() => {
        this.showPopup = true
      })
    },
    closePopup() {
      this.restorePageScroll()
      this.$nextTick(() => {
        this.showPopup = false
      })
    },
    // 选中日期
    selectDay(index) {
      if (this.currentIndex === index) {
        return
      }

      // 选中预约日期
      this.currentIndex = index

      // 重置预约时间
      this.currentTimeIndex = -1
      this.stateTimeObj = null
    },
    formatDateTime(dateTimeString) {
      // 将日期时间字符串分割成日期和时间两部分
      let parts = dateTimeString.split(' ')
      let date = parts[0]
      let time = parts[1]

      // 将时间部分进一步分割为小时、分钟和秒
      let timeParts = time.split(':')
      let hours = timeParts[0]
      let minutes = timeParts[1]
      let seconds = timeParts[2]

      // 检查小时部分是否为单位数，如果是，则在前面添加零（否则在 ios 下无法使用 new Date 方法）
      if (hours.length === 1) {
        hours = '0' + hours
      }

      // 重组格式化后的日期时间字符串
      return date + ' ' + [hours, minutes, seconds].join(':')
    },
    // 选中时间
    selectTime(week, item, index, day) {
      if (this.currentTimeIndex === index || item.expired) {
        return
      }

      // 选中预约时间
      this.currentTimeIndex = index

      // 处理时间
      const date = new Date(this.formatDateTime(item.time))
        .toLocaleDateString('en-US', {
          month: '2-digit',
          day: '2-digit'
        })
        .replace('/', '-')
      this.stateTimeObj = {
        time: item.time,
        showTime: `${date}（${week}）${item.newTimeslot}`,
        id: item.id,
        siteCode: item.siteCode,
        newTimeslot: item.newTimeslot,
        day
      }
      this.$emit('setHomeSiteInfo', item)
    },
    // 自动选中第一个可用的时间
    autoSelect() {
      if (this.autoIndex.timeAutoIndex === -1 || this.autoIndex.dayAutoIndex === -1) {
        return
      }

      // 选择日期
      this.selectDay(this.autoIndex.dayAutoIndex)

      // 选择时间
      this.selectTime(
        this.repairTimeList[this.autoIndex.dayAutoIndex].week,
        this.repairTimeList[this.autoIndex.dayAutoIndex].times[this.autoIndex.timeAutoIndex],
        this.autoIndex.timeAutoIndex,
        this.repairTimeList[this.autoIndex.dayAutoIndex].day
      )
      if (!this.stateTimeObj) {
        console.log('选择预约时间失败！请检查错误')
        return
      }
      this.SET_SELECTED_TIME(this.stateTimeObj)
      this.$emit('getRepairDefault')
    },
    // 确认选择
    selectConfirm() {
      if (this.currentTimeIndex === -1) {
        return
      }

      if (!this.stateTimeObj) {
        console.log('选择预约时间失败！请检查错误')
        return
      }

      this.SET_SELECTED_TIME(this.stateTimeObj)
      this.$emit('selectTimeConfirm')
      this.restorePageScroll()
      this.showPopup = false
    }
  }
}
</script>

<style lang="scss" src="./index.scss" scoped></style>
